/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/view_medium'
export default icon
